import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { downloadAttachment, getAttachmentCategory, getAttachmentDisplayName } from '../attachmentUtils';
import { AttachmentListProps } from '../attachment.types';
import { CategoryFileIcon, DownloadActionIcon, PaperclipIcon } from '../AttachmentIcons';
import styles from './AttachmentList.module.scss';

export const AttachmentList: FC<AttachmentListProps> = ({ attachments, title, showTitle = true, className }) => {
	const { t } = useTranslation();

	if (!attachments || attachments.length === 0) {
		return null;
	}

	return (
		<div className={cx(styles.container, className)}>
			{showTitle && (
				<div className={styles.titleRow}>
					<PaperclipIcon className={styles.titleIcon} />
					<span>{title || t('attachments', 'Attachments')}</span>
				</div>
			)}

			<div className={styles.grid}>
				{attachments.map((key, index) => {
					const displayName = getAttachmentDisplayName(key);
					const category = getAttachmentCategory(key);

					return (
						<div
							key={`${key}-${index}`}
							className={styles.itemCard}
							onClick={() => downloadAttachment(key, displayName)}
							role="button"
							tabIndex={0}
							onKeyDown={e => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									downloadAttachment(key, displayName);
								}
							}}
							title={t('click_to_download', 'Click to download {{name}}', { name: displayName })}
						>
							<div className={styles.itemCard_left}>
								<div className={styles.itemCard_iconWrap}>
									<CategoryFileIcon category={category} />
								</div>
								<span className={styles.itemCard_name}>{displayName}</span>
							</div>

							<button
								type="button"
								className={styles.downloadBtn}
								title={t('download' as any, 'Download')}
								aria-label={`Download ${displayName}`}
								onClick={e => {
									e.stopPropagation();
									downloadAttachment(key, displayName);
								}}
							>
								<DownloadActionIcon />
							</button>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default AttachmentList;
